import { FETCH_ROUTE_START, SAVE_ROUTE } from "../constants";

const INIT_STATE = {
  loading: false,
  routes: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_ROUTE_START: {
      return {
        ...state,
        loading: true
      };
    }
    case SAVE_ROUTE: {
      return {
        ...state,
        loading: false,
        routes: action.payload
      };
    }
    default:
      return state;
  }
};
